import React, { useEffect } from 'react';

const ShopKeyPoints = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-descdiv');
          }
        });
      },
      { threshold: 0.3 }
    );

    const descdivs = document.querySelectorAll('.descdiv');
    descdivs.forEach((descdiv) => observer.observe(descdiv));

    return () => {
      descdivs.forEach((descdiv) => observer.unobserve(descdiv));
    };
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains('it')) {
              entry.target.classList.add('animate-it');
            } else if (entry.target.classList.contains('ib')) {
              entry.target.classList.add('animate-ib');
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    const images = document.querySelectorAll('.d3img.it, .d3img.ib');
    images.forEach((image) => observer.observe(image));

    return () => {
      images.forEach((image) => observer.unobserve(image));
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-why');
          }
        });
      },
      { threshold: 0.3 }
    );

    const heading = document.querySelector('.d3wlcmh1div');
    if (heading) observer.observe(heading);

    return () => {
      if (heading) observer.unobserve(heading);
    };
  }, []);


  return (
    <div className='d3'>

      <hr className="hrnavbar" />

      <div className='d3wlcmh1div'>
        {/* <p className='d3wlcmh1sec'>Why</p>
        <h1 className='d3wlcmh1'>ChooseUs</h1> */}
        <img className='whychooseusimg' src="/images/whycus.png" alt="" />
      </div>

      {/* <div className="d3ins BRT">
        
        <div className="d3inside">
          <img className="d3img ib" src="/images/img1.png" alt="Sweets" />
          <div className="descdiv MB">
            <h1 className='d3p'>Freshly Made with Pure Ingredients</h1>
            <p>Our sweets are made fresh daily with 100% pure ingredients to give you the best taste and quality.</p>
          </div>
        </div>
      </div> */}

      <div className="d3ins BRT">

        <div className='kk1'>
          <img className='kkimg' src="/images/f3.png" alt="" />
          <img className='kkimg' src="/images/f4.png" alt="" />
        </div>

        <div className="gold-shine"></div>
        <div className="d3inside">
          <img className='bg33' src="/images/bg33.png" alt="" />
          <img
            className="d3img ib exttopmargin"
            src="/images/img1.png"
            alt="Sweets"
          />

          <div className="descdiv MB">

            <img className='keypointimg' src="/images/d1.png" alt="" />
            <h1 className="d3p">
              Freshly Made with Pure Ingredients
            </h1>
            <img className='keypointimg' src="/images/d1.png" alt="" />

            <p>
              Our sweets are made fresh daily with 100% pure ingredients
              to give you the best taste and quality.
            </p>

          </div>
        </div>

        <div className='kk2'>
          <img className='kkimg2 extbmargin' src="/images/f9.png" alt="" />
          <img className='kkimg2 extbmargin1' src="/images/f8.png" alt="" />
        </div>
      </div>

      <div className="d3ins">

        <div className='kk1'>
          <img className='kkimg' src="/images/f3.png" alt="" />
          <img className='kkimg' src="/images/f4.png" alt="" />
        </div>
        <div className="d3inside">
          <div className="descdiv MT">

            <img className='keypointimg' src="/images/d1.png" alt="" />
            <h1>We accept orders for weddings and other functions</h1>
            <img className='keypointimg' src="/images/d1.png" alt="" />

            <p>Make your celebrations sweeter with our fresh sweets and snacks. Contact us to make your moments memorable!</p>
          </div>

          <img className='bg34' src="/images/bg33.png" alt="" />
          <img className="d3img it" src="/images/img2.png" alt="Sweets" />
        </div>
        <div className='kk2'>
          <img className='kkimg2 extbmargin' src="/images/f9.png" alt="" />
          <img className='kkimg2 extbmargin1' src="/images/f8.png" alt="" />
        </div>
      </div>


      <div className="d3ins">

        <div className='kk1'>
          <img className='kkimg' src="/images/f3.png" alt="" />
          <img className='kkimg' src="/images/f4.png" alt="" />
        </div>
        <div className="d3inside">

          <img className='bg33' src="/images/bg33.png" alt="" />
          <img className="d3img ib exttopmargin" src="/images/cakechef.png" alt="Sweets" />
          <div className="descdiv MB">

            <img className='keypointimg' src="/images/d1.png" alt="" />
            <h1>Freshly Baked, Custom Cakes and Pastries</h1>
            <img className='keypointimg' src="/images/d1.png" alt="" />

            <p>Our cakes and pastries are baked fresh daily. For birthday, anniversary, or wedding, our cakes are baked to make memorable moments.</p>
          </div>
        </div>
        <div className='kk2'>
          <img className='kkimg2 extbmargin' src="/images/f9.png" alt="" />
          <img className='kkimg2 extbmargin1' src="/images/f8.png" alt="" />
        </div>
      </div>

      <div className="d3ins">

        <div className='kk1'>
          <img className='kkimg' src="/images/f3.png" alt="" />
          <img className='kkimg' src="/images/f4.png" alt="" />
        </div>
        <div className="d3inside">
          <div className="descdiv MT">

            <img className='keypointimg' src="/images/d1.png" alt="" />
            <h1>Special Sweets for Special Occasions</h1>
            <img className='keypointimg' src="/images/d1.png" alt="" />

            <p>At Roop Sweets, we believe every celebration deserves something special. For weddings, festivals, our sweets are made with love and care to make your occasion even sweeter.</p>
          </div>

          <img className='bg34' src="/images/bg33.png" alt="" />
          <img className="d3img ext it" src="/images/img3.png" alt="Sweets" />
        </div>
        <div className='kk2'>
          <img className='kkimg2 extbmargin' src="/images/f9.png" alt="" />
          <img className='kkimg2 extbmargin1' src="/images/f8.png" alt="" />
        </div>
      </div>


    </div>
  );
};

export default ShopKeyPoints;
